import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
// components
import DepartmentItem from './DepartmentItem.vue';

@Component({
    name: 'DepartmentList',
    components: { DepartmentItem },
})
export default class DepartmentList extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Array }) items!: orgmap.TreeListItem;
    @Prop({ type: String, default: 'name' }) headerField!: string;
    @Prop({ type: String, default: 'children' }) childrenField!: string;
    @Prop({ type: [String, Function] }) hasChildrenField!:
        | string
        | orgmap.EvaluateTreeListItemHasChildrenFuction;

    selectItem(item: any) {
        this.$emit('selectItem', item);
    }
}
